export function bgDots() {
    const $bodyOverlay = document.querySelector('.body-overlay');
    window.addEventListener('scroll', handleScroll);

    const range = 2000;
    let storedScrollY = window.scrollY;
    let scrollAccumulator = 0; // tracks total "travel" with direction
    let incrementValue = 0;
    let outputValue = 0;

    // initial call to set the value
    handleScroll();

    function handleScroll() {
        const currentScrollY = window.scrollY;
        const scrollDiff = currentScrollY - storedScrollY;

        // ~~~~~~~~~ AI generated code ~~~~~~~~~
        // accumulate scroll (positive down, negative up)
        scrollAccumulator += scrollDiff;

        // convert accumulator into an oscillating value between 0 and range
        // 1. Take absolute so direction doesn't matter for the phase.
        // 2. Mod by 2*range to get a repeating ramp.
        // 3. Reflect second half to make a triangle.
        const period = 2 * range;
        let phase = Math.abs(scrollAccumulator) % period;

        if ( phase <= range ) {
            incrementValue = phase; // going "up"
        } else {
            incrementValue = period - phase; // coming "down"
        }
        // ~~~~~~~~~ END AI generated code ~~~~~~~~~

        storedScrollY = currentScrollY;

        outputValue = incrementValue / range;
        outputValue = Math.round(outputValue * 1000) / 1000; // round to 3 decimal places

        // set the value to the CSS variable
        $bodyOverlay.style.setProperty('--bg-dot-value', outputValue);
    }
}